import { useEffect, useState, useCallback } from "react";
import { DatePicker, message } from "antd";
import { Chart, LineAdvance, Axis } from "bizcharts";
import moment from "moment-timezone";
// import { WebClient } from "../proto/sgn/gateway/v1/GatewayServiceClientPb";
import { ExplorerClient } from "../proto/sgn/explorer/v1/ExplorerServiceClientPb";
import { GetDailyTotalLiquidityRequest } from "../proto/sgn/explorer/v1/explorer_pb";
import { newGetTimeDistance } from "../utils/getTimeDistance";
import { convertUSD } from "../utils/newFormat";
import { serviceStartTime } from "../constans";

const RangePicker: any = DatePicker.RangePicker;

const axisConfig = {
  line: {
    style: {
      stroke: "#ccc",
      lineDash: [3, 3],
    }, // 设置坐标轴线样式
  },
  grid: {
    line: {
      style: {
        stroke: "#ccc",
        lineDash: [3, 3],
      },
    }, // 设置坐标系栅格样式
  },
};

interface IProps {
  reloadFlag: boolean;
}

const TotalLiquidityChart = (props: IProps) => {
  const { reloadFlag } = props;
  const [dailyLiquidityList, setDailyLiquidityList] = useState<
    Array<{
      time: string;
      totalLiquidity: number;
    }>
  >();
  const [rangePickerValue, setRangePickerValue] = useState<any>(
    newGetTimeDistance()
  );

  const handleRangePickerChange = (times: any) => {
    if (!times) {
      return;
    }
    const start = times[0];
    const end = times[1];
    start.hours(0);
    start.minutes(0);
    start.seconds(0);
    end.hours(23);
    end.minutes(59);
    end.seconds(59);
    const ary = [start, end];
    setRangePickerValue(ary);
  };

  const disabledDate = (current: any) => {
    // Can not select days after today and today, and can not before serviceStartTime
    return (
      current &&
      (current >= moment().startOf("day") || current < moment(serviceStartTime))
    );
  };

  const getData = useCallback(async () => {
    const start = moment(rangePickerValue[0].valueOf()).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    const end = moment(rangePickerValue[1].valueOf()).format(
      "YYYY-MM-DD HH:mm:ss"
    );
    const utcStart = moment.utc(start).valueOf();
    const utcEnd = moment.utc(end).valueOf();
    const client = new ExplorerClient(
      `${process.env.REACT_APP_GRPC_SERVER_URL}`,
      null,
      null
    );
    const getDailyTotalLiquidityRequest = new GetDailyTotalLiquidityRequest();
    getDailyTotalLiquidityRequest.setBegin(utcStart);
    getDailyTotalLiquidityRequest.setEnd(utcEnd);
    const res = await client.getDailyTotalLiquidity(
      getDailyTotalLiquidityRequest,
      null
    );
    if (res.hasErr()) {
      return message.error(
        `getDailyTransactionVolumeList Error：${res.getErr()?.getMsg()}`
      );
    }
    const dailyTotalliquidity = res.getDailyLiquidityList();
    const dailyLiquidityListData = dailyTotalliquidity?.map(
      (dailyLiquidity) => {
        const time = dailyLiquidity.getTime();
        const totalLiquidity = dailyLiquidity.getTotalLiquidity();
        return {
          time: moment(time).format("MMM DD"),
          totalLiquidity,
        };
      }
    );
    setDailyLiquidityList(dailyLiquidityListData);
  }, [rangePickerValue]);

  useEffect(() => {
    getData();
  }, [getData, reloadFlag]);

  return (
    <div className="chart charts-total-liquidity">
      <div className="chart-header">
        <div className="chart-header-title">Total Value Locked</div>
        <div className="chart-header-datepicker">
          <RangePicker
            value={rangePickerValue}
            onChange={handleRangePickerChange}
            onOk={handleRangePickerChange}
            format="MMM DD,YYYY"
            disabledDate={disabledDate}
          />
        </div>
      </div>
      <div className="chart-content">
        <Chart
          autoFit
          data={dailyLiquidityList}
          scale={{ totalLiquidity: { type: "linear-strict" } }}
        >
          <Axis
            name="totalLiquidity"
            label={{
              formatter: (val) => convertUSD(val, "round", 0),
            }}
            {...axisConfig}
          />
          <LineAdvance
            shape="smooth"
            point
            area
            position="time*totalLiquidity"
            tooltip={[
              "time*totalLiquidity",
              (text, totalLiquidity) => {
                return {
                  name: "Liquidity",
                  value: convertUSD(totalLiquidity, "round", 0),
                };
              },
            ]}
          />
        </Chart>
      </div>
    </div>
  );
};

export default TotalLiquidityChart;
